const sessionStorage = window.sessionStorage;

export const ssSave = (key: string, data: string) =>
	sessionStorage.setItem(key, JSON.stringify(data));
export const ssGet = (key: string) =>
	JSON.parse(sessionStorage.getItem(key) ?? '');
export const ssRemove = (key: string) => sessionStorage.removeItem(key);
